// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nocform {
    max-width: 600px;
    margin: auto;
    padding: 20px;
    background: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .nocform h2 {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .nocinput {
    width: 100%;
    padding: 10px;
    margin-bottom: 15px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 16px;
  }
  
  .nocbutton {
    width: 100%;
    padding: 10px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    font-size: 18px;
    cursor: pointer;
  }
  
  .nocbutton:hover {
    background: #0056b3;
  }
  
  @media (max-width: 768px) {
    .nocform {
      width: 90%;
    }
  }
  
.noc_table_container{
  overflow: auto;
}

  .noctable {
    width: 100%;
    border-collapse: collapse;
    margin: 20px 0;
    font-size: 16px;
    text-align: left;
}

.noctable th, .noctable td {
    border: 1px solid #ddd;
    padding: 10px;
}

.noctable th {
    background-color: #f4f4f4;
}

.noctable tr:nth-child(even) {
    background-color: #f9f9f9;
}

.noctable tr:hover {
    background-color: #f1f1f1;
}

.noc_downlode_buttons{
  display: flex;
  gap: 10px;
}
.noc_downlode_button{
  height: 40px;
  width: 120px;
  font-size: 14px;
  background-color: cadetblue;
  color: white;
  border: none;

}
.noc_close_button{
  height: 40px;
  width: 120px;
  font-size: 14px;
  background-color: red;
  color: white;
  border: none;
}
.noc_view_button{
  margin-left: 5px;
  height: 30px;
  width: 80px;
  font-size: 14px;
  background-color: cadetblue;
  color: white;
  border: none; 
}
.noc_delete_button{
  height: 30px;
  width: 80px;
  font-size: 14px;
  background-color: red;
  color: white;
  border: none; 
  margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/pages/latters/Noc.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uCAAuC;EACzC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;AAEF;EACE,cAAc;AAChB;;EAEE;IACE,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,YAAY;EACZ,YAAY;;AAEd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".nocform {\n    max-width: 600px;\n    margin: auto;\n    padding: 20px;\n    background: #f9f9f9;\n    border-radius: 8px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  .nocform h2 {\n    text-align: center;\n    margin-bottom: 20px;\n  }\n  \n  .nocinput {\n    width: 100%;\n    padding: 10px;\n    margin-bottom: 15px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    font-size: 16px;\n  }\n  \n  .nocbutton {\n    width: 100%;\n    padding: 10px;\n    background: #007bff;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    font-size: 18px;\n    cursor: pointer;\n  }\n  \n  .nocbutton:hover {\n    background: #0056b3;\n  }\n  \n  @media (max-width: 768px) {\n    .nocform {\n      width: 90%;\n    }\n  }\n  \n.noc_table_container{\n  overflow: auto;\n}\n\n  .noctable {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 20px 0;\n    font-size: 16px;\n    text-align: left;\n}\n\n.noctable th, .noctable td {\n    border: 1px solid #ddd;\n    padding: 10px;\n}\n\n.noctable th {\n    background-color: #f4f4f4;\n}\n\n.noctable tr:nth-child(even) {\n    background-color: #f9f9f9;\n}\n\n.noctable tr:hover {\n    background-color: #f1f1f1;\n}\n\n.noc_downlode_buttons{\n  display: flex;\n  gap: 10px;\n}\n.noc_downlode_button{\n  height: 40px;\n  width: 120px;\n  font-size: 14px;\n  background-color: cadetblue;\n  color: white;\n  border: none;\n\n}\n.noc_close_button{\n  height: 40px;\n  width: 120px;\n  font-size: 14px;\n  background-color: red;\n  color: white;\n  border: none;\n}\n.noc_view_button{\n  margin-left: 5px;\n  height: 30px;\n  width: 80px;\n  font-size: 14px;\n  background-color: cadetblue;\n  color: white;\n  border: none; \n}\n.noc_delete_button{\n  height: 30px;\n  width: 80px;\n  font-size: 14px;\n  background-color: red;\n  color: white;\n  border: none; \n  margin-left: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
